export const TIME_PARAM_FORMAT = 'HH:mm:ss';
export const DATE_FORMAT = 'YYYY/MM/DD';
export const DEFAULT_SHIFT_FORMAT = 'HH:mm:ss';
export const US_TIME_FORMAT = 'hh:mm A';

export const RETRY_MAX_TRIES = 100000;
export const RETRY_DELAY_LENGTH = 10;
